import {
  Amwins_Orbits_Contracts_Models_v2_Inspections_InspectionInfo,
  Amwins_Orbits_Contracts_Models_ProductType,
  Amwins_Orbits_Contracts_Models_Inspections_InspectionProvider,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class InspectionsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static inspectionStatus(
    params: {
      /**  */
      policyId?: string;
      /**  */
      policyNumber?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Amwins_Orbits_Contracts_Models_v2_Inspections_InspectionInfo> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/invoke/Inspections/api/Policy/InspectionStatus';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { policyId: params['policyId'], policyNumber: params['policyNumber'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
